var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('v-img',_vm._g({attrs:{"contain":"","width":_vm.width,"src":_vm.src}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }